import { render } from "./EditTestimoni.vue?vue&type=template&id=525c5b4c"
import script from "./EditTestimoni.vue?vue&type=script&lang=js"
export * from "./EditTestimoni.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__